<script>
  import {onMount} from "svelte";
  import {parsePercent} from "../../Common/tools";
  import {External, M} from "../../external";
  import {AB_CONTENT, AB_SUBJECT, WIN_TYPE_OPEN} from "../../Campaign/static";

  export let data;
  let id;
  let emailPreviewUrl = "";
  let iframeWrapper;
  let iframeHeight = 500;
  let showLoserSubject = false;
  let subTab;
  let loserSubjectWrapper;

  const A = "A", B = "B";

  function toggleLoserSubject() {
    showLoserSubject = !showLoserSubject;
    loserSubjectWrapper[showLoserSubject ? "slideDown" : "slideUp"]("fast");
  }

  function switchSubTab(t) {
    subTab = t;
    emailPreviewUrl = "/me/email?preview=1&id=" + id + "&split=" + t.toLowerCase();
  }

  function getRateDesc(rate) {
    const desc = data.data.winType === WIN_TYPE_OPEN ? M.PERCENT_OPEN_RATE : M.PERCENT_CLICK_RATE;
    return desc.replace("%", parsePercent(rate));
  }

  onMount(function () {
    loserSubjectWrapper = External.$("#loserSubjectWrapper");

    if (data.type === AB_CONTENT) {
      subTab = data.data.abStats?.winner ? data.data.abStats.winner : A;
    }

    id = External.WebPlatform.getUrlQueryParameter(window.location.href, "id");

    if (id) {
      emailPreviewUrl = "/me/email?preview=1&id=" + id;
      if (subTab) {
        emailPreviewUrl += "&split=" + subTab.toLowerCase();
      }
    }

    let rect = iframeWrapper.getBoundingClientRect();
    iframeHeight = Math.max(External.$(window).height() - rect.top - 16);
  });
</script>

<div class="text-center mt-25" bind:this={iframeWrapper} style="height: {iframeHeight}px; padding-bottom: 0; overflow:clip">
  <span class="col20 f-left ta-center campaign-winners">
    {#if data.data.abStats?.winner}
      {#if data.data.abStats.winner === A}
        {#if data.type === AB_SUBJECT}
          {M.WINNER_A} ({getRateDesc(data.data.abStats.winnerRate)}) - {data.subject}
        {:else}
          {data.subject}
        {/if}
      {:else}
        {#if data.type === AB_SUBJECT}
          {M.WINNER_B} ({getRateDesc(data.data.abStats.winnerRate)}) - {data.subjectB}
        {:else}
          {data.subject}
        {/if}
      {/if}

      {#if data.type === AB_SUBJECT}
        <a on:click={toggleLoserSubject} class="f-right mr-10">
          {#if showLoserSubject}
            &#x2212;
          {:else}
            &#x2b;
          {/if}
        </a>
      {/if}

      <span id="loserSubjectWrapper" class="col20 f-left ta-center none-soft campaign-losers">
        <span style="margin-right: 32px">
          {#if data.data.abStats.winner === A}
            {M.LOSER_B} ({getRateDesc(data.data.abStats.loserRate)}) - {data.subjectB}
          {:else}
            {M.LOSER_A} ({getRateDesc(data.data.abStats.loserRate)}) - {data.subject}
          {/if}
        </span>
      </span>
    {:else}
      {data.subject}
      {#if data.subjectB}
        / {data.subjectB}
      {/if}
    {/if}
  </span>

  {#if subTab}
    <div class="upper-navigation upper-navigation-full col20 f-left mt-15 mb-25 flex justify-center">
      <ul style="background: #f5f6fa; border-radius: 3px;">
        <li class="upper-navigation-item">
          <a class:active={subTab === A} on:click={() => switchSubTab(A)}>
            {#if data.data.abStats}
              {#if data.data.abStats.winner === A}
                {M.WINNER_A} - {parsePercent(data.data.abStats.winnerRate)}
              {:else}
                {M.LOSER_A} - {parsePercent(data.data.abStats.loserRate)}
              {/if}
            {:else}
              {M.DESIGN_A}
            {/if}
          </a>
        </li>
        <li class="upper-navigation-item">
          <a class:active={subTab === B} on:click={() => switchSubTab(B)}>
            {#if data.data.abStats}
              {#if data.data.abStats.winner === B}
                {M.WINNER_B} - {parsePercent(data.data.abStats.winnerRate)}
              {:else}
                {M.LOSER_B} - {parsePercent(data.data.abStats.loserRate)}
              {/if}
            {:else}
              {M.DESIGN_B}
            {/if}
          </a>
        </li>
      </ul>
    </div>
  {/if}

  {#if emailPreviewUrl}
    <iframe src={emailPreviewUrl} title="Email Template Preview" style="width:100%; height: calc(100% - 52px)"></iframe>
  {/if}
</div>
